import React from 'react';
import { useLocation } from 'react-router-dom';

// Step groups: maps route keywords to one of the 5 high-level steps
const STEP_GROUPS = [
  {
    id: 1,
    label: 'Login Details',
    description: 'Your account & contact info',
    routes: ['welcome', 'login_details'],
  },
  {
    id: 2,
    label: 'Space Details',
    description: 'Location, images & description',
    routes: ['organization_details', 'space_details', 'space_location', 'uploading_images', 'external_systems'],
  },
  {
    id: 3,
    label: 'Pricing Details',
    description: 'Capacity, pricing & availability',
    routes: [
      'space_and_notice',
      'tax_information',
      'seating_and_common',
      'seating_arrangement',
      'pricing_options',
      'amenities',
      'addons',
      'rules',
      'calendar_sync',
    ],
  },
  {
    id: 4,
    label: 'Payout Details',
    description: 'Bank & payout information',
    routes: ['payout_details', 'commission'],
  },
  {
    id: 5,
    label: 'Review',
    description: 'Host agreement & submit your listing',
    routes: ['agreement', 'congratulations', 'Congratulations'],
  },
];

const getStepStatus = (step, pathname) => {
  const isCongratulations = pathname.includes('congratulations') || pathname.includes('Congratulations');
  if (isCongratulations) return 'completed';

  const isActive = step.routes.some((r) => pathname.includes(r));
  if (isActive) return 'active';

  // Find active step group index
  const activeGroupIdx = STEP_GROUPS.findIndex((g) => g.routes.some((r) => pathname.includes(r)));
  const stepIdx = STEP_GROUPS.findIndex((g) => g.id === step.id);

  if (activeGroupIdx === -1) {
    // welcome page — first step is active
    return step.id === 1 ? 'active' : 'pending';
  }

  if (stepIdx < activeGroupIdx) return 'completed';
  return 'pending';
};

const getStepLabel = (step, pathname) => {
  const isCongratulations = pathname.includes('congratulations') || pathname.includes('Congratulations');
  if (isCongratulations && step.id === 5) {
    return 'Finish';
  }
  return step.label;
};

const getStepDesc = (step, pathname) => {
  const isCongratulations = pathname.includes('congratulations') || pathname.includes('Congratulations');
  if (isCongratulations && step.id === 5) {
    return 'Successfully listed!';
  }
  return step.description;
};

const ListingStepper = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="sl-stepper-panel">
      <div className="sl-stepper-inner">
        {STEP_GROUPS.map((step, idx) => {
          const status = getStepStatus(step, pathname);
          return (
            <div key={step.id} className={`sl-step sl-step--${status}`}>
              <div className="sl-step-indicator-col">
                <div className="sl-step-circle">
                  {status === 'completed' ? (
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 5.5L5 9.5L13 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : (
                    <span className="sl-step-number">{String(step.id).padStart(2, '0')}</span>
                  )}
                </div>
                {idx < STEP_GROUPS.length - 1 && (
                  <div className={`sl-step-connector ${status === 'completed' ? 'sl-step-connector--done' : ''}`} />
                )}
              </div>
              <div className="sl-step-content">
                <div className="sl-step-label">{getStepLabel(step, pathname)}</div>
                <div className="sl-step-desc">{getStepDesc(step, pathname)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListingStepper;
